import {
  Component,
  OnInit
} from '@angular/core';

import { AppState } from '../app.service';
import { Title,Meta } from '@angular/platform-browser';
import {CompanyService} from "../services/company-service/company-service";
import {CompanyVM} from "../models/CompanyVM.model";



@Component({
  /**
   * The selector is what angular internally uses
   * for `document.querySelectorAll(selector)` in our index.html
   * where, in this case, selector is the string 'home'.
   */
  selector: 'rw-servantListHome',  // <home></home>
  /**
   * We need to tell Angular's Dependency Injection which providers are in our app.
   */
  //providers: [
  //  Title
  //],
  /**
   * Our list of styles in our component. We may add more to compose many styles together.
   */
  styles: [require('./servantListHome.component.css')],
  /**
   * Every Angular template is first compiled by the browser before Angular runs it's compiler.
   */
  template: require('./servantListHome.component.html')
})
export class ServantListHomeComponent implements OnInit {

  /**
   * Set our default values
   */
  public  isCardViewMode=false;
  public isParent=false;
  public localState = {value: ''};
  public company:CompanyVM;
  public themeType='DEFAULT_THEME';
  clientBookingComponentType = 'DEFAULT';
  /**
   * TypeScript public modifiers
   */
  constructor(public appState:AppState, private pageTitle:Title,private companyService:CompanyService) {
  }

  public ngOnInit() {
    /**
     * this.title.getData().subscribe(data => this.data = data);
     */
    this.setPageTitle();

  }
  public setServiceViewMode(c:CompanyVM)
  {
    this.isCardViewMode=false;
    if(c.activityType!='OTHER')
    {
      this.isCardViewMode=true;
    }
  }
  public checkIfIsParentCompany(company:CompanyVM)
  {
    this.isParent=false;
    if(company.customSetting)
    {
      let isParent= this.companyService.getCompanyCustomSetting(company,'isParent');

      if(isParent && (isParent=='true' || isParent==true))
      {
        this.isParent=true;
      }

      this.clientBookingComponentType = this.companyService.getCompanyCustomSetting(company, 'clientBookingWidgetType');

    }

  }
  public setPageTitle()
  {
    let title='صفحه اصلی';
    let parent=this;
    this.companyService.getCompanyInfo().subscribe((c)=>{
         parent.company=c;
      this.pageTitle.setTitle(c.title+" - "+title);
      parent.setServiceViewMode(c);
      parent.checkIfIsParentCompany(c);
      parent.checkTheme(c);

    })
  }
  public submitState(value:string) {
    this.appState.set('value', value);
    this.localState.value = '';
  }

  checkTheme(company){

    const parent = this;

    if (company && company.setting && company.setting.themeSettingInfo
      && company.setting.themeSettingInfo.themeType && company.setting.themeSettingInfo.themeType == 'MODERN_THEME') {
      parent.themeType = 'MODERN_THEME';
    }
    else
    {
      parent.themeType = 'DEFAULT_THEME';
    }
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/servantListHome/servantListHome.component.ts